import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { Toaster } from '@/components/ui/sonner';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Clients from './pages/Clients';
import Consultants from './pages/Consultants';
import Projects from './pages/Projects';
import TimeEntries from './pages/TimeEntries';
import Invoices from './pages/Invoices';
import Receipts from './pages/Receipts';
import Expenses from './pages/Expenses';
import Reports from './pages/Reports';
import HRCommissions from './pages/HRCommissions';
import ConsultantPayments from './pages/ConsultantPayments';
import Ledger from './pages/Ledger';
import ActivityLogs from './pages/ActivityLogs';
import Users from './pages/Users';
import ImportExport from './pages/ImportExport';
import Communications from './pages/Communications';
import BankReconciliation from './pages/BankReconciliation';
import DashboardLayout from './components/DashboardLayout';
import ProtectedRoute from './components/ProtectedRoute';
import PortalApp from './portal/PortalApp';
import '@/App.css';

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/portal/*" element={<PortalApp />} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <DashboardLayout>
                  <Routes>
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/clients" element={<Clients />} />
                    <Route path="/consultants" element={<Consultants />} />
                    <Route path="/projects" element={<Projects />} />
                    <Route path="/time-entries" element={<TimeEntries />} />
                    <Route path="/invoices" element={<Invoices />} />
                    <Route path="/receipts" element={<Receipts />} />
                    <Route path="/expenses" element={<Expenses />} />
                    <Route path="/communications" element={<Communications />} />
                    <Route path="/ledger" element={<Ledger />} />
                    <Route path="/reports" element={<Reports />} />
                    <Route path="/bank-reconciliation" element={<BankReconciliation />} />
                    <Route path="/hr-commissions" element={<HRCommissions />} />
                    <Route path="/consultant-payments" element={<ConsultantPayments />} />
                    <Route path="/activity-logs" element={<ActivityLogs />} />
                    <Route path="/users" element={<Users />} />
                    <Route path="/import-export" element={<ImportExport />} />
                  </Routes>
                </DashboardLayout>
              </ProtectedRoute>
            }
          />
        </Routes>
        <Toaster position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}
